import { Strategy } from "src/common/Strategy";
import { z } from "zod";

const zTableSettingsV1 = z.object({
  version: z.literal("1"),
  data: z.object({
    hiddenColumns: z.string().array(),
    pageSize: z.optional(z.number()),
    resizableColumns: z.optional(z.boolean()),
    columnWidths: z.record(z.string(), z.number().or(z.string())).optional(),
    columnOrder: z.array(z.string()).optional(),
    fixedLeft: z.number().optional(),
  }),
});

const zTableSettings = z.discriminatedUnion("version", [zTableSettingsV1]);
export type ZTableSettings = z.infer<typeof zTableSettings>;

// Обработка кейса когда мы заходим на новую таблицу и версия нам неизвестна, предполагает что настройки будут сохранены в последней версии
export const getLatestVersion = (): ZTableSettings["version"] =>
  [...zTableSettings.options]
    .map((schema) => schema.shape.version.value)
    .sort()
    .pop()!;

export class TableStrategy implements Strategy<ZTableSettings> {
  constructor(readonly defSettings: ZTableSettings) {}

  settings: ZTableSettings | null = null;

  bind(data?: ZTableSettings) {
    if (!data) return;
    this.settings = zTableSettings.parse(data);
  }

  execute(): ZTableSettings {
    return this.settings ?? this.defSettings;
  }
}
